import request from '../common'

export function chatImage (data) {
    return request({
        url: '/chat/image?noLoading',
        method: 'post',
        data: data
    })
}

export function chatText (data) {
    return request({
        url: '/chat/creation?noLoading',
        method: 'post',
        data: data
    })
}

export function chatTextV2 (data) {
    return request({
        url: '/chat/v2?noLoading',
        method: 'post',
        data: data
    })
}

export function chatV3 (data) {
  return request({
    url: '/chat/v3?noLoading',
    method: 'post',
    data: data
  })
}

export function chatV3Param (data) {
  return request({
    url: '/chat/v3/params?noLoading',
    method: 'post',
    data: data
  })
}

export function chatV3ParamNew (data) {
  return request({
    url: '/chat/v3/params/new?noLoading',
    method: 'post',
    data: data
  })
}

export function chatV4Params (data) {
  return request({
    url: '/chat/v4/params?noLoading',
    method: 'post',
    data: data
  })
}

export function chatChat (data) {
    return request({
        url: '/chat/chat?noLoading',
        method: 'post',
        data: data
    })
}


export function chatSpecific (data) {
    return request({
        url: '/chat/specific?noLoading',
        method: 'post',
        data: data
    })
}

export function pageChat () {
    return request({
        url: '/page/chat',
        method: 'get'
    })
}

export function pageCreate () {
    return request({
        url: '/page/createV2',
        method: 'get'
    })
}

export function packageList () {
    return request({
        url: '/package',
        method: 'get'
    })
}

export function packageAppraise () {
    return request({
        url: '/package/appraise',
        method: 'get'
    })
}

export function packagePurchased () {
    return request({
        url: '/package/purchased',
        method: 'get'
    })
}

export function packageChatSpecific () {
    return request({
        url: '/page/chat/specificV2',
        method: 'get'
    })
}
        


// WEBPACK FOOTER //
// ./src/api/create.js